<div class="selector-cobertura">
  <div class="section-title">
    {{ 'PYMES.TITLE' | translate }}
  </div>

  <div class="opciones-container">
    <button *ngFor="let option of coverageOptions; trackBy: trackByOptionId" type="button" class="option-card"
      [class.option-card--selected]="form.get('coverage').value === option.id"
      [attr.aria-pressed]="form.get('coverage').value === option.id" (click)="selectCoverage(option.id)">
      <div class="caja" [class.seleccionada]="form.get('coverage').value === option.id"
        [class.deshabilitada]="deshabilitada">
        <!-- <span class="option-card__label">Selecciona</span> -->
        <span class="option-card__title">{{ option.title }}</span>
        <span class="option-card__description">{{ option.description }}</span>
      </div>
    </button>
  </div>

  <div *ngIf="form.get('coverage').value === 'con-hospitalizacion'">
    <div class="section-title section-title--secondary"> {{ 'PYMES.HOSPITALIZATION' | translate }} </div>

    <div class="opciones-container">
      <button *ngFor="let option of medicalOptions; trackBy: trackByOptionId" type="button" class="option-card"
        [class.option-card--selected]="form.get('medical').value === option.id"
        [attr.aria-pressed]="form.get('medical').value === option.id" (click)="selectMedicalOption(option.id)">

        <div class="caja" [class.seleccionada]="form.get('medical').value === option.id"
          [class.deshabilitada]="deshabilitada">
          <!-- <span class="option-card__label">Selecciona</span> -->
          <span class="option-card__title">{{ option.title }}</span>
          <span class="option-card__description">{{ option.description }}</span>
        </div>

      </button>
    </div>
  </div>
</div>
